const API_BASE = '/api';

export const configurationService = {
    // Obter todas as configurações
    async getAll() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Erro ao carregar configurações');
        return response.json();
    },

    // Obter configurações por categoria
    async getByCategory(category) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/category/${category}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Erro ao carregar configurações');
        return response.json();
    },

    // Obter estado de uma categoria
    async getCategoryStatus(category) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/category/${category}/status`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Erro ao carregar estado');
        return response.json();
    },

    // Obter lista de categorias
    async getCategories() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/categories`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Erro ao carregar categorias');
        return response.json();
    },

    // Atualizar uma configuração
    async update(key, value, isEnabled) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ key, value, isEnabled })
        });
        if (!response.ok) throw new Error('Erro ao atualizar');
        return response.json();
    },

    // Atualizar múltiplas configurações
    async updateBatch(configs) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/batch`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(configs)
        });
        if (!response.ok) throw new Error('Erro ao atualizar');
        return response.json();
    },

    // Ativar/desativar categoria
    async toggleCategory(category, enabled) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/category/${category}/toggle`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(enabled)
        });
        if (!response.ok) throw new Error('Erro ao atualizar');
        return response.json();
    },

    // Inicializar configurações padrão
    async initialize() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/initialize`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Erro ao inicializar');
        return response.json();
    },

    // Testar email
    async testEmail(email) {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/test/email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ email })
        });
        return response.json();
    },

    // Testar Stripe
    async testStripe() {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_BASE}/configuration/test/stripe`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.json();
    },

    // Obter chave Stripe pública
    async getStripePublishableKey() {
        const response = await fetch(`${API_BASE}/configuration/stripe/publishable-key`);
        return response.json();
    }
};

export default configurationService;
